import { call, put } from 'redux-saga/effects';
import { ACTIONS, APIS } from '../../_config';
import { CallApi } from '../api/callApi';


export function* FilteredServiceProviderList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.VENDORS.FILTERED_SERVICE_PROVIDER_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {            
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* FilteredServiceProviderListRedux(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.VENDORS.REDUX_FILTERED_SERVICE_PROVIDER_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            let key = ACTIONS.MASTER.ELECTRICITY_PROVIDERS;
            if (data.vendorServiceTypeIDs[0] == 1) {
                key = ACTIONS.MASTER.ELECTRICITY_PROVIDERS;
            } else if (data.vendorServiceTypeIDs[0] == 2) {
                key = ACTIONS.MASTER.TELEPHONE_PROVIDERS;
            } else if (data.vendorServiceTypeIDs[0] == 3) {
                key = ACTIONS.MASTER.GAS_PROVIDERS
            } else if (data.vendorServiceTypeIDs[0] == 4) {
                key = ACTIONS.MASTER.WATER_PROVIDERS
            }
            console.log("Key is -> ", key);
            yield put({
                type: key,
                payload: resp.data.vendorList.map((service: any) => {
                    return {
                        label: service.name,
                        value: service.vendorID,
                    }
                })
            });
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveVendorDetails(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.VENDORS.SAVE_VENDOR_DETAILS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetVendorList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.VENDORS.GET_VENDOR_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* SaveVendorFiles(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.VENDORS.SAVE_VENDOR_FILES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetVendorByID(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.VENDORS.GET_VENDOR_BY_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* DeleteVendor(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.VENDORS.DELETE_VENDOR + "?VendorID=" + data.VendorID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetServiceType(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.VENDORS.GET_SERVICE_TYPE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* Exportcsv(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.VENDORS.EXPORT_TO_CSV, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* Exportpdf(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.VENDORS.EXPORT_TO_PDF, data, true, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetAttachment(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.VENDORS.GET_VENDOR_ATTACHMENT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetVendorCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.VENDORS.GET_VENDOR_CODE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}